import React, { useState } from 'react';
import Reveal from './Reveal';
import Lightbox from './Lightbox';
import './Gallery.css';

/**
 * variant: 'mosaic' (editorial, uneven) | 'grid' (even) | 'strip' (horizontal scroll)
 */
export default function Gallery({ items, variant = 'mosaic', className = '' }) {
  const [open, setOpen] = useState(null);
  if (!items?.length) return null;

  return (
    <>
      <ul className={`gallery gallery--${variant}${className ? ` ${className}` : ''}`}>
        {items.map((item, i) => (
          <Reveal
            as="li"
            key={`${item.src}-${i}`}
            className="gallery__cell"
            variant="zoom"
            delay={(i % 4) * 0.08}
          >
            <button
              type="button"
              className="gallery__btn frame frame--hover"
              onClick={() => setOpen(i)}
              aria-label={`Open image ${i + 1} of ${items.length}`}
            >
              <img src={item.src} alt={item.alt || ''} loading="lazy" />
              <span className="gallery__zoom" aria-hidden="true">
                +
              </span>
            </button>
          </Reveal>
        ))}
      </ul>

      <Lightbox items={items} index={open} onClose={() => setOpen(null)} onIndex={setOpen} />
    </>
  );
}
